import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { OrderResponse } from '../../order'
import { ReservationResponse } from '../../reservation'
import { TableResponse } from '../../room-plan'
import { TableState } from './enums'

export class DashboardTableView {
	@ApiProperty({ type: TableResponse })
	tableRef: TableResponse

	@ApiPropertyOptional({ type: ReservationResponse })
	reservation?: ReservationResponse

	@ApiPropertyOptional({ type: OrderResponse })
	order?: OrderResponse

	@ApiProperty({ enum: TableState })
	tableState: TableState
}
